import { render, staticRenderFns } from "./IngredientsReportView.vue?vue&type=template&id=86be561e&scoped=true"
import script from "./IngredientsReportView.vue?vue&type=script&lang=js"
export * from "./IngredientsReportView.vue?vue&type=script&lang=js"
import style0 from "./IngredientsReportView.vue?vue&type=style&index=0&id=86be561e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86be561e",
  null
  
)

export default component.exports